import React from "react";
import { defaultSetup } from "./config";
import Option1 from "./Layout/Option1";
import Option2 from "./Layout/Option2";
import Option3 from "./Layout/Option3";
import Option9 from "./Layout/Option9";
import Option4 from "./Layout/Option4";
import Option5 from "./Layout/Option5";
import Option6 from "./Layout/Option6";
import Option7 from "./Layout/Option7";
import Option8 from "./Layout/Option8";
import Option10 from "./Layout/Option10";
import Option11 from "./Layout/Option11";
import Option12 from "./Layout/Option12";
import Option13 from "./Layout/Option13";

const InfoCardNewAdv = ({
  title = "Title",
  titleConfig = {},
  //
  value,
  valueConfig = {},
  //
  prefix = "",
  prefixConfig = {},
  //
  suffix = "",
  suffixConfig = {},
  //
  description = "",
  descriptionConfig = {},
  //
  icon = "",
  iconConfig = {},
  //
  backValue = "",
  backValueConfig = {},
  //
  layout = "option1", // option1, option2, option3, option4, custom
  layoutConfig = {},
  renderCustomLayout = null,
  //
  bgConfig = {},
  onClick = null,
  //
  isLoading = false,
}) => {
  const renderField = () => {
    switch (layout) {
      case "option1":
        return (
          <Option1
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option2":
        return (
          <Option2
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option3":
        return (
          <Option3
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option4":
        return (
          <Option4
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option5":
        return (
          <Option5
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option6":
        return (
          <Option6
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option7":
        return (
          <Option7
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option8":
        return (
          <Option8
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option9":
        return (
          <Option9
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option10":
        return (
          <Option10
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option11":
        return (
          <Option11
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option12":
        return (
          <Option12
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );
      case "option13":
        return (
          <Option13
            title={title}
            titleConfig={titleConfig}
            value={value}
            valueConfig={valueConfig}
            prefix={prefix}
            prefixConfig={prefixConfig}
            suffix={suffix}
            suffixConfig={suffixConfig}
            description={description}
            descriptionConfig={descriptionConfig}
            icon={icon}
            backValue={backValue}
            backValueConfig={backValueConfig}
            iconConfig={iconConfig}
            bgConfig={bgConfig}
            layoutConfig={layoutConfig}
            onClick={onClick}
            isLoading={isLoading}
          />
        );

      default:
        return null; // You can render a default component if needed
    }
  };
  //
  const bgClassName = [defaultSetup.bgConfig.className, bgConfig.className]
    .filter(Boolean)
    .join(" ");

  return (
    <React.Fragment>
      {renderCustomLayout ? renderCustomLayout() : renderField()}
    </React.Fragment>
  );
};

export default InfoCardNewAdv;
